import React from 'react';
import i18next from 'i18next';
import GlobalStore from 'stores/globalStore';

const ENIcon = () => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" className="flag-icon" viewBox="0 0 640 480">
        <path fill="#012169" d="M0 0h640v480H0z"/>
        <path fill="#FFF" d="m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z"/>
        <path fill="#C8102E" d="m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z"/>
        <path fill="#FFF" d="M241 0v480h160V0H241zM0 160v160h640V160H0z"/>
        <path fill="#C8102E" d="M0 193v96h640v-96H0zM273 0v480h96V0h-96z"/>
      </svg>
      <span className="hide-sp">English</span>
    </>
  );
};

const VIIcon = () => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" className="flag-icon" viewBox="0 0 640 480">
        <defs>
          <clipPath id="vn-a">
            <path fillOpacity=".7" d="M-85.3 0h682.6v512H-85.3z"/>
          </clipPath>
        </defs>
        <g fillRule="evenodd" clipPath="url(#vn-a)" transform="translate(80) scale(.9375)">
          <path fill="#da251d" d="M-128 0h768v512h-768z"/>
          <path fill="#ff0" d="M349.6 381 260 314.3l-89 67.3L204 272l-89-67.7 110.1-1 34.2-109.4L294 203l110.1.1-88.5 68.4 33.9 109.6z"/>
        </g>
      </svg>
      <span className="hide-sp">Tiếng Việt</span>
    </>
  );
};

const LanguageDropdown: React.FC = () => {
  const { currentLanguage, switchLanguage } = GlobalStore.useContainer();
  
  const handleSwitchLanguage = (code:string) => {
    i18next.changeLanguage(code);
    switchLanguage(code);
  };
  return (
    <ul className="language-dropdown">
      <li>
        <button
          className={'language-option' + (currentLanguage === 'vi' ? ' is-current' : '')}
          onClick={() => handleSwitchLanguage('vi')}
        >
          <VIIcon />
        </button>
      </li>
      <li>
        <button
          className={'language-option' + (currentLanguage === 'en' ? ' is-current' : '')}
          onClick={() => handleSwitchLanguage('en')}
        >
          <ENIcon />
        </button>
      </li>
    </ul>
  )
}
export { VIIcon, ENIcon }
export default LanguageDropdown;
